import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledCheckBox = styled.label`
  /* Customize the label (the container) */
  position: relative;
  padding-left: 35px;
  margin-bottom: 16px;
  cursor: pointer;
  font-size: 15px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: ${props => props.theme.colors.blue2};

  /* Hide the browser's default radio button */
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    width: 24px;
    background-color: white;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  /* On mouse-over, add a grey background color */
  &:hover input ~ .checkmark {
    background-color: #eee;
  }

  /* When the radio button is checked, add a blue background */
  input:checked ~ .checkmark {
    background-color: ${props => props.theme.colors.blue1};
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .checkmark:after {
    left: 9px;
    top: 5px;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

export function CheckBox({ id, value, label, handleChange, initialCheck, className }) {
  const [checked, setChecked] = useState(initialCheck);

  return (
    <StyledCheckBox htmlFor={id} className={className}>
      {label}
      <input
        type="checkbox"
        id={id}
        value={value}
        checked={checked}
        onChange={e => {
          setChecked(e.target.checked);
          handleChange();
        }}
      />
      <span className="checkmark" />
    </StyledCheckBox>
  );
}

CheckBox.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  initialCheck: PropTypes.bool,
  className: PropTypes.string,
};

CheckBox.defaultProps = {
  initialCheck: false,
};
